<!-- 
  @description: 案件信息管理
  @author: dhx
 -->
<template>
  <div class="case-info full d-s-s d-r">
    <section class="left w-50">
      <!-- 标题栏 -->
      <div class="info-title d-s-c d-r">
        <i class="icon-shield"></i>
        <h2>案件信息</h2>
        <div class="ml20">
          案件状态：<span class="red">{{event_status}}</span>
        </div>
        <div class="ml20">
          案件ID：<span>{{order_no}}</span>
        </div>
      </div>

      <div class="dhx__grid_line"></div>

      <!-- 详情信息 -->
      <OrderInfo :dataList="list"></OrderInfo>
    </section>
    <section class="right w-50">
      <SectionRight :caseId="caseId"></SectionRight>
    </section>
  </div>
</template>
<script>
import options from "./contact.js";

export default options;
</script>
<style lang="scss" scoped>
@import url("./style.scss");
</style>


// WEBPACK FOOTER //
// src/views/collection/manage/index.vue